// @ts-ignore
import packageJson from '../../package.json';

export const environment = {
  production: true,
  hostOrigin: 'https://localhost:4400',
  proxyOrigin: 'http://localhost:4000',
  appVersion: packageJson.version
};
